import { Page } from "@/models/page-models/Page";

export const Suppliers: Page = {
  "path": "suppliers",
  "name": "Supplier Master",
  "props": {
    "data": {
      "title": "Supplier Master",
      "printable": "FALSE",
      "url": "suppliers",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Add Supplier",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "redirectToAddSupplier"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "primary"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "table",
                  "variable": "formData",
                  "label": "Suppliers List",
                  "disabled": "FALSE",
                  "items": "fetchedData.supplierList.data",
                  "headers": [
                    {
                      "value": "__item._id",
                      "text": "Supplier #",
                      "type": "url",
                      "url": "/suppliers/{{__item._id}}"
                    },
                    {
                      "value": "__item.name",
                      "text": "Supplier Name"
                    },
                    {
                      "value": "__item.address.formatted_address",
                      "text": "Address"
                    },
                    {
                      "value": "__item.landline",
                      "text": "Landline"
                    },
                    {
                      "value": "__item.contacts",
                      "text": "Contacts",
                      "type": "formula",
                      "formula": "{{__item.name}}({{__item.email}}) {{__item.mobile}}",
                      "multipleItemsVariable": "contacts"
                    },
                    {
                      "value": "__item.createdAt",
                      "text": "Date Created",
                      "type": "date",
                      "formula": "fn(HELPER_FN,dateFormat,{{__item.createdAt}})"
                    },
                    {
                      "value": "__item.status",
                      "text": "Status"
                    }
                  ],
                  "tableType": "static",
                  "showActions": true,
                  "selectableUniqueId": "_id",
                  "groupActions": [
                    {
                      "label": "Approve",
                      "disableIf": "fn(LOGICAL,fn(KEYED_ARRAY_SUM,fn(LOGICAL,fn(CONCAT,',{{__arrayItem.status}},'),==,'Approved'),{{__item}},_id),>,0)",
                      "onClick": [
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "approveSupplier",
                            "type": "fnSubmit",
                            "arg1Key": "apiUrl",
                            "arg1Value": "/api/v1/suppliers/{{__item._id}}/approve",
                            "arg2Key": "postData",
                            "arg2Value": "{}"
                          },
                          "name": "approveSupplier"
                        },
                        {
                          "executionOrder": 2,
                          "pageFunction": {
                            "name": "getAllSuppliers",
                            "type": "fnGetData",
                            "arg1Key": "apiUrl",
                            "arg1Value": "/api/v2/suppliers",
                            "arg2Key": "storeInVar",
                            "arg2Value": "fetchedData.supplierList"
                          },
                          "name": "getSuppliers",
                          "executeOnce": true
                        }
                      ]
                    },
                    {
                      "label": "Reject",
                      "disableIf": "fn(LOGICAL,fn(KEYED_ARRAY_SUM,fn(LOGICAL,fn(CONCAT,',{{__arrayItem.status}},'),==,'Rejected'),{{__item}},_id),>,0)",
                      "onClick": [
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "rejectSupplier",
                            "type": "fnSubmit",
                            "arg1Key": "apiUrl",
                            "arg1Value": "/api/v1/suppliers/{{__item._id}}/reject",
                            "arg2Key": "postData",
                            "arg2Value": "{}"
                          },
                          "name": "rejectSupplier"
                        },
                        {
                          "executionOrder": 2,
                          "pageFunction": {
                            "name": "getAllSuppliers",
                            "type": "fnGetData",
                            "arg1Key": "apiUrl",
                            "arg1Value": "/api/v2/suppliers",
                            "arg2Key": "storeInVar",
                            "arg2Value": "fetchedData.supplierList"
                          },
                          "name": "getSuppliers",
                          "executeOnce": true
                        }
                      ]
                    }
                  ],
                  "neverHideActionBar": true
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getAllSuppliers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/suppliers",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.supplierList"
        },
        "name": "getAllSuppliers",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,Commercial | Purchaser))"
      }
    ],
    "functions": [
      {
        "name": "redirectToAddSupplier",
        "type": "fnRedirect",
        "arg1Key": "redirectUrl",
        "arg1Value": "/suppliers/new"
      }
    ]
  },
  "forRole": "COMMERCIAL_MANAGER",
  "visible": true,
  "routerPriority": 80
}